import {
  Directive,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  Output,
  EventEmitter,
  inject,
} from '@angular/core';

@Directive({
  selector: '[appCheckOverflow]',
  standalone: true,
})
export class CheckOverflowDirective implements AfterViewInit, OnDestroy {
  @Output() overflows = new EventEmitter<boolean>();

  private elementRef = inject(ElementRef<HTMLElement>);
  private observer: ResizeObserver;

  constructor() {
    // Use ResizeObserver to efficiently detect when the element's size changes
    this.observer = new ResizeObserver(() => this.check());
  }

  ngAfterViewInit(): void {
    this.observer.observe(this.elementRef.nativeElement);
    // Check initially after the view has been rendered
    setTimeout(() => this.check(), 0);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }

  private check(): void {
    const element = this.elementRef.nativeElement;
    // The core logic: is the scrollable height greater than the visible height?
    const isOverflowing = element.scrollHeight > element.clientHeight;
    this.overflows.emit(isOverflowing);
  }
}
